export const UPDATE_EXPIRING_PROGRAM_CARRIER =
  "UPDATE_EXPIRING_PROGRAM_CARRIER";
export const UPDATE_EXPIRING_PROGRAM_LIMIT = "UPDATE_EXPIRING_PROGRAM_LIMIT";
export const UPDATE_EXPIRING_PROGRAM_ATTACHMENT =
  "UPDATE_EXPIRING_PROGRAM_ATTACHMENT";
export const UPDATE_EXPIRING_PROGRAM_MARKET_GROSS_WRITTEN_PREMIUM =
  "UPDATE_EXPIRING_PROGRAM_MARKET_GROSS_WRITTEN_PREMIUM";
export const DELETE_EXPIRING_PROGRAM_LAYER = "DELETE_EXPIRING_PROGRAM_LAYER";
export const REPLACE_EXPIRING_PROGRAM_LAYERS =
  "REPLACE_EXPIRING_PROGRAM_LAYERS";
